<template lang="pug">
.category-group
  //- small {{ menu0 }} {{ menu1 }} {{ menu2 }} {{ menu3 }}
  //- br
  //- small {{ live[1].tn }} {{ today[1].tn }} {{ early[1].tn }}
  .scrolling-wrapper
    template(v-if="menu1 == 'mmoparlay'")
      .category.active
        .live {{ $t("ui.live") }}
        .sport-icon.inactive
          ThemeImage(src='images/light/sport/blue/1.svg')
        .sport-icon.active
          ThemeImage(src='images/light/sport/white/1.svg')
        .sport-name {{ sports[1] }} 
        .event-count {{ totalCount(1) }}
    template(v-else)
      template(v-for="n in order")
        .category(:key="n" v-if="items[n]" @click="showSelected(n)" :class="{ 'active' : selectedSportType == n }")
          .live(v-if="live[n] && live[n].tn > 0") {{ $t("ui.live") }}
          .sport-icon.inactive
            ThemeImage(:src="'/images/light/sport/blue/' + n + '.svg'")
          .sport-icon.active
            ThemeImage(:src="'/images/light/sport/white/' + n + '.svg'")
          .sport-name {{ sports[n] }}
          .event-count {{ totalCount(n) }}
</template>

<script>
import config from "@/config";
import { EventBus } from "@/library/_event-bus.js";
import naming from "@/library/_name.js";

export default {
  props: {
    mode: {
      type: Number
    },
    order: {
      type: Array,
      default: () => []
    },
    items: {
      type: Object,
      default: () => {}
    },
    live: {
      type: Object,
      default: () => {}
    },
    today: {
      type: Object,
      default: () => {}
    },
    early: {
      type: Object,
      default: () => []
    },
    sports: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      options: {}
    };
  },
  computed: {
    selectedSportType() {
      return this.menu2;
    },
    selectedSportName() {
      return this.sports[this.menu2];
    },
    selectedCount() {
      if (this.items != null && this.items[this.menu2] != null && this.items[this.menu2].hasOwnProperty("tn")) {
        return this.items[this.menu2].tn;
      } else {
        return 0;
      }
    },
    lang() {
      return this.$store.getters.language;
    },
    menu0() {
      return this.$store.getters.menu0;
    },
    menu1() {
      return this.$store.getters.menu1;
    },
    menu2() {
      return this.$store.getters.menu2;
    },
    menu3() {
      return this.$store.getters.menu3;
    },
    isOutrightEmpty() {
      return this.today[this.menu2] != null && this.today[this.menu2].hasOwnProperty("orz") && this.today[this.menu2].orz <= 0;
    }
  },
  watch: {
    menu2() {
      this.$nextTick(() => {
        this.scrollToActive();
      });
    }
  },
  mounted() {
    this.initial();
    this.$nextTick(() => {
      this.scrollToActive();
    });
  },
  methods: {
    totalCount(e) {
      // When in parlay mode, use items prop (parlayMenu) directly
      if (this.menu3 === 'parlay') {
        if (this.items[e] && this.items[e].tn > 0) {
          return this.items[e].tn;
        }
        return 0;
      }
      
      // For other modes, sum up live, today, and early
      let count = 0;
      if (this.live[e] && this.live[e].tn > 0) {
        count += this.live[e].tn;
      }
      if (this.today[e] && this.today[e].tn > 0) {
        count += this.today[e].tn;
      }
      if (this.early[e] && this.early[e].tn > 0) {
        count += this.early[e].tn;
      }
      return count;
    },
    getSportsImage(e) {
      return e == 0 ? "all.svg?v=12" : config.getSportsImage(e);
    },
    initial() {
      var sportsList = Object.keys(this.items);
      if (!sportsList.includes(this.menu2.toString())) {
        if (sportsList.length > 0) {
          var x = sportsList[0];
          if(this.mode) {
            this.showSelected(x);
          }
        }
      }
    },
    scrollToActive() {
      // Use requestAnimationFrame to ensure DOM is fully rendered
      requestAnimationFrame(() => {
        const scrollingWrapper = this.$el.querySelector('.scrolling-wrapper');
        if (!scrollingWrapper) return;
        
        const activeCategory = scrollingWrapper.querySelector('.category.active');
        if (!activeCategory) return;
        
        const wrapperRect = scrollingWrapper.getBoundingClientRect();
        const activeRect = activeCategory.getBoundingClientRect();
        
        // Check if active item is already visible
        const isVisible = activeRect.left >= wrapperRect.left && 
                         activeRect.right <= wrapperRect.right;
        
        if (isVisible) return;
        
        // Calculate scroll position to center the active item
        const scrollLeft = scrollingWrapper.scrollLeft;
        const activeLeft = activeRect.left - wrapperRect.left + scrollLeft;
        const activeWidth = activeRect.width;
        const wrapperWidth = wrapperRect.width;
        
        // Center the active item in the viewport
        const targetScroll = activeLeft - (wrapperWidth / 2) + (activeWidth / 2);
        
        // Use scrollTo with smooth behavior, fallback to scrollLeft for older browsers
        if (scrollingWrapper.scrollTo) {
          scrollingWrapper.scrollTo({
            left: targetScroll,
            behavior: 'smooth'
          });
        } else {
          scrollingWrapper.scrollLeft = targetScroll;
        }
      });
    },
    showSelected(e) {
      const sportId = parseInt(e);
      let selectedMenu1 = 'today';
      let selectedMenu0 = 'all';
      let selectedMenu = null;
      let selectedMenu3 = 'hdpou';

      // If currently in parlay mode, keep parlay mode and check parlay menu
      if (this.menu3 === 'parlay') {
        if (this.items[sportId] && this.items[sportId].tn > 0) {
          selectedMenu1 = 'today';
          selectedMenu0 = 'all';
          selectedMenu3 = 'parlay';
          selectedMenu = this.items[sportId];
        } else {
          // Sport doesn't have parlay matches, but keep parlay mode
          selectedMenu1 = 'today';
          selectedMenu0 = 'all';
          selectedMenu3 = 'parlay';
        }
      } else {
        // Check market availability by priority: live > today > early
        if (this.live[sportId] && this.live[sportId].tn > 0) {
          selectedMenu1 = 'live';
          selectedMenu0 = 'live';
          selectedMenu = this.live[sportId];
        } else if (this.today[sportId] && this.today[sportId].tn > 0) {
          selectedMenu1 = 'today';
          selectedMenu0 = 'all';
          selectedMenu = this.today[sportId];
        } else if (this.early[sportId] && this.early[sportId].tn > 0) {
          selectedMenu1 = 'early';
          selectedMenu0 = 'all';
          selectedMenu = this.early[sportId];
        }

        // Use chooseBetType to determine the appropriate menu3 value
        if (selectedMenu) {
          selectedMenu3 = naming.chooseBetType(sportId.toString(), selectedMenu, this.menu3);
        }
      }

      var mi5 = {};
      mi5["menuX"] = false;
      mi5["menuY"] = "0";
      mi5["menu0"] = selectedMenu0;
      mi5["menu1"] = selectedMenu1;
      mi5["menu2"] = sportId;
      mi5["menu3"] = selectedMenu3;

      // Set live options when navigating to live market, clear for others
      const options = {};
      if (selectedMenu1 === 'live') {
        options[sportId] = true;
        // Clear games list items
        if (config.gamesList) {
          for (var i = 0; i < config.gamesList.length; i++) {
            options[config.gamesList[i]] = false;
          }
        }
        this.$store.dispatch("layout/setOptions", { property: "live", value: options });
      } else {
        // Clear all options for non-live markets
        if (config.gamesList) {
          for (var i = 0; i < config.gamesList.length; i++) {
            options[config.gamesList[i]] = false;
          }
        }
        this.$store.dispatch("layout/setOptions", { property: "live", value: options });
      }

      // Set selected days based on sport type
      if (config.day1 && config.day1.includes(sportId)) {
        this.$store.dispatch("layout/setSelectedDays", "1");
      } else {
        this.$store.dispatch("layout/setSelectedDays", "0");
      }

      this.$store.dispatch("layout/setMenuItems", mi5);
      EventBus.$emit("INVALIDATE", mi5);
      
      // Scroll to active after state update
      this.$nextTick(() => {
        this.scrollToActive();
      });
    }
  }
};
</script>
